import React, { Dispatch, SetStateAction } from "react";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { FormControl, MenuItem, Select } from "@mui/material";

type props = {
  module: any;
  page: number;
  onPageChange: (newPage: number) => void;
  totalPages: number;
  totalCount: number;
  setPage: Dispatch<SetStateAction<number>>;
  limit?: number; // Items per page
};

export default function Pagination({
  module,
  page,
  onPageChange,
  totalPages,
  setPage,
  totalCount,
  limit = 10, // Default to 10 if not provided
}: props) {
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, totalCount);
  const currentPageItems = module?.length ?? 0;
  
  return (
    <div className="pagination_wrp">
      <p>
        {totalPages > 1 ? (
          <>
            Showing <strong>{startIndex}</strong> to <strong>{endIndex}</strong> from{" "}
            <strong>{totalCount ?? 0}</strong> data
          </>
        ) : (
          <>
            Showing <strong>{currentPageItems}</strong> from{" "}
            <strong>{totalCount ?? 0}</strong> data
          </>
        )}
      </p>

      <div className="pagination_number">
        {totalPages > 5 ? (
          <FormControl fullWidth className="all_page">
            <Select
              className="dropse"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              inputProps={{
                "aria-label": "Without label",
              }}
              displayEmpty
              value={page}
              onChange={(pages: any) => setPage(pages.target.value)}
            >
              <MenuItem value="" disabled>
                Select
              </MenuItem>
              {Array.from({ length: totalPages }).map((_, index) => (
                <MenuItem key={index + 1} value={index + 1}>
                  {index + 1}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : null}
        <button
          className="page_icon first_icon"
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
        >
          <KeyboardDoubleArrowLeftIcon className="mat_icon" />
        </button>
        <ul className="pagination_list">
          {totalPages > 4
            ? Array.from({ length: totalPages })
              .slice(0, 3)
              .map((_, index) => (
                <li key={index} className={page === index + 1 ? "active" : ""}>
                  <button
                    type="button"
                    onClick={() => onPageChange(index + 1)}
                    disabled={page === index + 1}
                    aria-current={page === index + 1 ? "page" : undefined}
                  >
                    {index + 1}
                  </button>
                </li>
              ))
              .concat(
                <li key="ellipsis" className="ellipsis">
                  <span aria-hidden="true">…</span>
                </li>,
                <li
                  key="middle"
                  style={{
                    display: page < 4 || page === totalPages ? "none" : undefined,
                  }}
                  className={page === totalPages ? "active" : ""}
                >
                  <button type="button" disabled>
                    {page}
                  </button>
                </li>,
                <li
                  key={totalPages}
                  className={page === totalPages ? "active" : "inActv"}
                >
                  <button
                    type="button"
                    onClick={() => onPageChange(totalPages)}
                    disabled={page === totalPages}
                    aria-current={page === totalPages ? "page" : undefined}
                  >
                    {totalPages}
                  </button>
                </li>
              )
            : Array.from({ length: totalPages }).map((_, index) => (
              <li
                key={index}
                className={page === index + 1 ? "active" : "inActv"}
              >
                <button
                  type="button"
                  onClick={() => onPageChange(index + 1)}
                  disabled={page === index + 1}
                  aria-current={page === index + 1 ? "page" : undefined}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

        {/* <ul className="pagination_list">
          <li className="active">1</li>
          <li>2</li>
          <li>3</li>
          <li>4</li>
        </ul> */}
        <button
          className="page_icon"
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
        >
          <KeyboardDoubleArrowRightIcon className="mat_icon" />
        </button>
      </div>
    </div>
  );
}
